/**
 * Nested menu.
 *
 * This code is common for horizontal and vertical nested menus.
 */
const menu_nested = (args) => {
    let menu = args.menu;

    if (!menu) {
        return;
    }

    /**
     * Event: Menu caret clicked
     *
     * Open sub-menu and change caret state
     */
    function caretClickEvent(e) {
        // console.log('Menu caret clicked');

        const li = e.currentTarget.closest('.menu-item-has-children');

        const result = H_Tools.nestedmenu.toggleMenuItem(menu, li);

        if (result > 0) {
            li.dispatchEvent(new Event('caretopened'));
        }

        // don't trigger parent(s)
        e.stopPropagation();
    }

    /**
     * Event: Click on empty link (a[href="#"])
     */
    function emptyLinkClickEvent(e) {
        // cancel default action
        e.preventDefault();

        const li = e.currentTarget.closest('.menu-item-has-children');
        if (li) {
            if (li.classList.contains('-is-clicked')) {
                H_Tools.nestedmenu.deactivateMenuItem(li);
                li.classList.remove('-is-clicked');
            } else {
                H_Tools.nestedmenu.activateMenuItem(menu, li);
                li.classList.add('-is-clicked');
            }
        }
    }

    // close all menus
    H_Tools.nestedmenu.resetMenuItems(menu);

    // setup click hooks (carets)
    const menuCarets = menu.querySelectorAll('.js-menu-caret');
    for (let k = 0; k < menuCarets.length; k++) {
        menuCarets[k].addEventListener('click', caretClickEvent);
    }

    // setup click hooks (empty links)
    const emptyLinks = menu.querySelectorAll('a:not([href])');
    for (let l = 0; l < emptyLinks.length; l++) {
        emptyLinks[l].addEventListener('click', emptyLinkClickEvent);
        emptyLinks[l].setAttribute('aria-hidden', true);
    }
};

document.querySelectorAll('.js-menu-nested').forEach((menu) => {
    menu_nested({
        menu: menu,
    });
});
